module.exports = __webpack_public_path__ + "img/gnzs2.da029500.png";